var $ffd690f838a0e29e$exports = {};
$ffd690f838a0e29e$exports = {
    "pending": `\u{5F85}\u{5904}\u{7406}`
};


export {$ffd690f838a0e29e$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
